import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class CorVeiculoService {
	private data = null;
	private url = environment.serviceApi;

	constructor(public http: Http) { }

	getCoresVeiculo(ordem=null) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/coresveiculo' + (ordem? '/ordem/' + ordem : ''))
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getCorVeiculo(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/coresveiculo/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	criaCorVeiculo(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/coresveiculo', {
				cor_veiculo_nome: data.cor_veiculo_nome,
				status: '1'
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	editaCorVeiculo(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/coresveiculo/' + data.cor_veiculo_id, {
				cor_veiculo_nome: data.cor_veiculo_nome,
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	apagaCorVeiculo(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/coresveiculo/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	editaCorVeiculoStatus(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/coresveiculo/' + data.cor_veiculo_id, {
				status: data.status,
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

}
